import API from "./index"

export default {
  findAll(params) {
    return API.get("api/autorizacaofornecedor", { params });
  },
  findById(id) {
    return API.get(`api/autorizacaofornecedor/${id}`);
  },
  create(autorizacaoFornecedor) {
    return API.post("api/autorizacaofornecedor", autorizacaoFornecedor);
  },
  delete(id) {
    return API.delete(`api/autorizacaofornecedor/${id}`);
  },
  update(id, autorizacaoFornecedor) {
    return API.put(`api/autorizacaofornecedor/${id}`, autorizacaoFornecedor);
  }
};
